var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import EditableSection from 'components/v2/EditableSection';
import Select from 'components/v2/select';
const Commercial = ({ data, onUpdateShipper, className }) => {
    const { t } = useTranslation();
    const [initialData, setInitialData] = useState({});
    const [commercialData, setCommericalData] = useState({});
    const getInitData = () => {
        if (data) {
            setInitialData(data);
            setCommericalData(data);
        }
    };
    useEffect(() => {
        getInitData();
    }, []);
    const onChange = (field, value) => {
        setCommericalData((prev) => (Object.assign(Object.assign({}, prev), { [field]: value })));
    };
    const handleSave = async () => {
        const updates = {};
        const { admins, salesReps } = commercialData, changed = __rest(commercialData, ["admins", "salesReps"]);
        Object.keys(changed).forEach((key) => {
            if (initialData[key] !== changed[key]) {
                updates[key] = changed[key];
            }
        });
        if (Object.keys(updates).length) {
            await onUpdateShipper(updates);
        }
    };
    const handleAfterSave = (onSaveSuccess) => {
        return (updatedData = {}) => {
            setInitialData((prev) => (Object.assign(Object.assign({}, prev), updatedData)));
            onSaveSuccess();
        };
    };
    return (React.createElement(EditableSection, { title: t('COMMERCIAL'), className: classNames(className), canEdit: true }, (editing, saving, onSaveSuccess, onSaveFail) => !editing ? (React.createElement(CommercialSummary, { fields: initialData })) : (React.createElement(CommercialForm, { fields: commercialData, onChange: onChange, onSaveShipper: () => handleSave(), saving: saving, onSaveSuccess: handleAfterSave(onSaveSuccess), onSaveFail: onSaveFail }))));
};
const CommercialSummary = ({ fields = {} }) => {
    const { t } = useTranslation();
    const { sales_rep, account_manager } = fields;
    const na = t('NONE');
    return (React.createElement("div", { className: "grid grid-cols-1 gap-4" },
        React.createElement(DescriptionListItem, { label: t('SALES_REP') }, sales_rep || na),
        React.createElement(DescriptionListItem, { label: t('ACCOUNT_MANAGER') }, account_manager || na)));
};
const CommercialForm = ({ fields, onChange, saving, onSaveShipper, onSaveSuccess, onSaveFail, }) => {
    const { t } = useTranslation();
    const saveForm = async () => {
        try {
            await onSaveShipper();
            onSaveSuccess(fields);
        }
        catch (e) {
            onSaveFail();
        }
    };
    useEffect(() => {
        if (saving) {
            saveForm();
        }
    }, [saving]);
    const { salesReps, admins } = fields;
    return (React.createElement("div", { className: "grid gap-4" },
        React.createElement(Select, { items: salesReps, valueKey: "slug", textKey: "name", selected: fields.sales_rep, onSelect: ({ slug }) => onChange('sales_rep', slug), info: t('ACCOUNT_SALES_REP'), label: t('SALES_REP'), inputClassNames: "lg:w-4/5 w-1/2" }),
        React.createElement(Select, { items: admins, valueKey: "slug", textKey: "name", selected: fields.account_manager, onSelect: ({ slug }) => onChange('account_manager', slug), info: t('ACCOUNT_MANAGER_REPRESENTATIVE'), label: t('ACCOUNT_MANAGER'), inputClassNames: "lg:w-4/5 w-1/2" })));
};
export default Commercial;
